/**
 * # signalr-converter
 *
 * Logic to translate JSON transport data from SignalR
 * connection to the target model/contract declared in
 * this library.
 *
 * ## Duration
 *
 * Convert duration fields. In SignalR transport, duration
 * fields always have `Duration` suffix, and are string-formatted
 * time spans in format 'hh:mm:ss[.f...]'. In the models in this
 * library these fields instead have the suffix `Ms` and represent
 * the integer number of milliseconds.
 *
 */
/** Valid formatted time span pattern */
const rxTimeSpan = /^(\d+):(\d{1,2}):(\d{1,2})(\.\d+)?$/;
/** Convert timeSpan formatted as string `h[h]:m[m]:s[s][.f...]` to integer milliseconds */
export function timeSpanToMs(timeSpan) {
    if (typeof timeSpan != 'string')
        return null;
    const match = rxTimeSpan.exec(timeSpan);
    if (match == null)
        return null;
    return (Math.round(1000 * parseFloat(match[4]) || 0) + // ms
        1000 * parseInt(match[3]) + // s
        60000 * parseInt(match[2]) + // m
        3600000 * parseInt(match[1]) // h
    );
}
/** Replace *Duration field with converted *Ms field */
export function replaceDuration(target, field) {
    if (target == null)
        return;
    const duration = target[field + 'Duration'];
    target[field + 'Ms'] = timeSpanToMs(duration);
    delete target[field + 'Duration'];
}
/** Recursively located and convert all duration fields */
export function replaceDurations(target) {
    for (const [k, v] of Object.entries(target)) {
        if (v == null) {
            continue;
        }
        if (typeof v == 'object') {
            replaceDurations(v);
            continue;
        }
        const l = k.length;
        if (l <= 8)
            continue;
        if (k.substring(l - 8) == 'Duration') {
            const field = k.substring(0, l - 8);
            replaceDuration(target, field);
        }
    }
}
/**
 * Translate a SignalR event to the target model defined in this library.
 * This implementation updates the properties in-place.
 */
export function translateEvent(signalrEvent) {
    try {
        replaceDurations(signalrEvent);
    }
    catch (e) {
        console.warn(`Error translating SignalR payload: ${e}`);
    }
    return signalrEvent;
}
//# sourceMappingURL=signalr-converter.js.map